import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import fontAwesomeCss from 'font-awesome/css/font-awesome.min.css';
import bootstrapCss from 'bootstrap/dist/css/bootstrap.min.css';
import normalizeCss from 'normalize.css';
import slickCarouselCss from 'slick-carousel/slick/slick.css';
import slickThemeCss from 'slick-carousel/slick/slick-theme.css';

import { getAuthFromCookie, getCookieValue } from '../../utils/cookie';
import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer';
import Placeholder from '../Placeholder';
import CookiePrompt from './CookiePrompt';
import SnackBar from '../SnackBar';
import { ACTIONS } from '../../reducers/layout';
import getPlatformUrl from '../../utils/login';
import history from '../../history';
import { logoutUser } from '../../actions/sagAuth';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    alertMessage: PropTypes.string.isRequired,
    alertType: PropTypes.string.isRequired,
    init: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    showFooter: PropTypes.bool,
  };

  static contextTypes = {
    auth: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  };

  static defaultProps = {
    showFooter: true,
  };

  constructor() {
    super();
    this.state = {
      isCookieConsentGiven: true,
    };
  }

  componentDidMount() {
    this.props.init();
    const isCookieConsentGiven = document.cookie.includes(
      'cookie_consent=true',
    );
    // this.handleGoToPlatform();
    this.setState({ isCookieConsentGiven });
  }

  saveConsent = () => {
    this.setState({ isCookieConsentGiven: true });
  };

  handleGoToPlatform = async () => {
    const { user } = this.props.auth;
    const currPath = history.location && history.location.pathname;
    const isLogoutUrl = currPath === '/logout';
    const isTrackMailUrl = currPath === '/track-mail';
    if (isEmpty(user) || isLogoutUrl || isTrackMailUrl) {
      return;
    }

    const redirectUrl = getPlatformUrl({
      organizationSubdomain: user.subdomain_url,
      websiteHost: window.location.host,
    });
    window.location.replace(redirectUrl);
  };

  render() {
    const {
      children,
      isLoginPage,
      alertMessage,
      contactFields,
      isSendingMsg,
      alertType,
      setAlert,
      headerBackground,
      showFooter,
      hideHeader,
      changeFields,
      submitContactUs,
      underMaintenance,
      logoutUser,
      auth: { token, refreshToken, user },
    } = this.props;
    const { isCookieConsentGiven } = this.state;
    const isLoggedIn = !!refreshToken;

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        isLoggedIn,
        token,
        refreshToken,
        userName: user && user.name,
        userId: user && user.user_id,
        subdomain: user && user.subdomain_url,
      }),
    );

    const currPath = history.location && history.location.pathname;
    const isLogoutUrl = currPath === '/logout';
    const isTrackMailUrl = currPath === '/track-mail';

    return (
      <div>
        {!hideHeader && !underMaintenance && (
          <Header
            isLoggedIn={isLoggedIn}
            user={user}
            logoutUser={logoutUser}
            isCookieConsentGiven={isCookieConsentGiven}
            headerBackground={headerBackground}
          />
        )}
        {!isCookieConsentGiven && (
          <CookiePrompt
            styles={s}
            isLoginPage={isLoginPage}
            hideCookie={this.hideCookie}
            saveConsent={this.saveConsent}
          />
        )}
        {childrenWithProps}
        <SnackBar
          showOnce={!!alertMessage}
          message={alertMessage}
          type={alertType}
          onEnd={() => setAlert(null, null)}
        />
        {showFooter && !underMaintenance && (
          <Footer
            contactFields={contactFields}
            changeFields={changeFields}
            submitContactUs={submitContactUs}
            isSendingMsg={isSendingMsg}
          />
        )}
      </div>
    );
  }
}

const mapState = state => ({
  alertMessage: state.layout.alertMessage,
  alertType: state.layout.alertType,
  contactFields: state.layout.contactFields,
  isSendingMsg: state.layout.isSendingMsg,
  auth: state.routes.auth,
});

const mapDispatch = {
  init: ACTIONS.init,
  setAlert: ACTIONS.setAlert,
  submitContactUs: ACTIONS.submitContactUs,
  changeFields: ACTIONS.changeFields,
  logoutUser,
};

export default connect(
  mapState,
  mapDispatch,
)(
  withStyles(
    bootstrapCss,
    normalizeCss,
    fontAwesomeCss,
    s,
    slickCarouselCss,
    slickThemeCss,
  )(Layout),
);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js